import axios from 'axios';
import config from '~config';
import Vue from 'vue';
import qs from 'qs';
import cookie from 'js-cookie';
import HttpScheduler from 'http-scheduler/dist/bundle-umd';
import store from '@/store';

const vm = new Vue();
const api = {};

// 默认定制化配置
const defaultConfigObj = {
  isSilent: false,
  silentCodes: [],
};
const customizeConfigObj = {};

const isError = false;

const http = axios.create({
  baseURL: config.api,
  timeout: 60000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: status => status === 200,
});

const httpScheduler = new HttpScheduler({
  httpEngine: http,
  concurrentMax: 4,
});

// 映射axios请求方法进api对象中，并增加定制化配置参数
['get', 'post', 'put', 'delete'].forEach((method) => {
  api[method] = (url, param = {}, specialObj = {}) => {
    if (method === 'get') {
      param = param.params
        ? Object.assign({}, param, specialObj)
        : { params: param, ...specialObj };
    }

    const symbol = method === 'post'
      ? `${url}_${qs.stringify(param)}`
      : `${url}_${qs.stringify(param.params)}`;
    // console.log('\n\n\n===========\n', url, '\n', param, '\n', symbol);
    customizeConfigObj[symbol] = Object.assign(
      {},
      defaultConfigObj,
      specialObj,
    );

    // request header里面传入Gtcrm字段，存放accessToken
    // const gtcrm = 'Gtcrm';
    // axios.headers[gtcrm] = sessionStorage.getItem('token');

    let priority = 1;
    try {
      // param中的$_priority属性被当作是权重
      priority = param.$_priority || param.params.$_priority || priority;
      if (param.$_priority) delete param.$_priority;
      else delete param.params.$_priority;
    } catch (e) {
      // 无用
    }

    // console.log(`派发请求：${url}，权重：${priority}`);
    // console.log('http', url, axios.defaults);
    // console.log(priority, method, url, JSON.stringify(param), specialObj);
    return httpScheduler.dispatch(priority, method, url, param, specialObj);
  };
});

// 请求拦截
http.interceptors.request.use(
  (apiconfig) => {
    window.cookie = cookie;
    const XCsrfToken = cookie.get('__grms_rf_crm_');
    if (XCsrfToken) {
      apiconfig.headers['X-CsrfToken'] = XCsrfToken;
    }
    apiconfig.headers['Gtcrm'] = sessionStorage.getItem('token');
    return apiconfig;
  },
  e =>
    // console.log('e', e);
    Promise.reject(e),
);

// 响应拦截
http.interceptors.response.use(
  (res = {}) => {
    // res.data.code = 502;
    try {
      if (res.data && +res.data.code >= 400) {
        // 错误提示
        vm.$message({
          message: res.data.message,
          type: 'error',
          duration: 1000,
        });
      }
      if (res.data && +res.data.code >= 500) {
        store.state.authority = {};
      }

      return Promise.resolve(res);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  (e) => {
    if (!e.response) {
      return Promise.reject(e);
    }
    const errRes = e.response;
    const errData = errRes.data || {};
    let symbol = null;
    console.log('error', errRes);

    try {
      symbol = errRes.config.method === 'post'
        ? `${errRes.config.url}_${qs.stringify(
          JSON.parse(errRes.config.data),
        )}`
        : `${errRes.config.url}_${qs.stringify(errRes.config.params)}`;
      // console.log('\n\n\n////////////////////\n', errRes, '\n', symbol);
    } catch (err) {
      console.error(`symbol获取失败: ${err.message}`);
    }

    const crmErrCodes = [
      'CRM_KANO_1',
      'CRM_KANO_2',
      'CRM_KANO_3',
      'CRM_KANO_4',
      'CRM_KANO_5',
      'CRM_KANO_7',
      'CRM_BASE_2',
    ];
    if (
      errRes.status >= 400
      && crmErrCodes.some(v => v === errData.code)
      && errData.message
    ) {
      vm.$message({
        message: errData.message,
        type: 'error',
        duration: 1500,
      });
    } else if (
      errRes.status >= 400
      && errData.code === 'CRM_LOGIN_6'
      && errData.message
    ) {
      // 未登录，跳转到登录页
      location.href = errData.message;
    } else if (
      errRes.status >= 400
      && customizeConfigObj[symbol]
      && !customizeConfigObj[symbol].isSilent
      && !customizeConfigObj[symbol].silentCodes.includes(errData.code)
    ) {
      // 此项目大多数错误码都做了定制化的处理，故无需统一报错，只触发系统错误。
      const errorMsg = errData.violationItems && errData.violationItems.length > 0
        ? errData.violationItems[0].message
        : errData.message;
      vm.$message({
        message: errorMsg,
        type: 'error',
        duration: 1500,
      });
    }

    if (errRes.config.url === '/api/common/crmAuth' && errRes.status >= 500) {
      // store.state.authority = {};
      window.location.href = '/502';
    }
    // 未知的系统错误
    if (e.code === '1') {
      vm.$message({
        message: '未知的系统错误',
        type: 'error',
        duration: 1000,
      });
      return Promise.reject(e);
    }
    // 超时
    if (e.code === 'ECONNABORTED') {
      vm.$message({
        message: '网络超时,请刷新后重试',
        type: 'error',
        duration: 1000,
      });
      return Promise.reject(e);
    }
    // 处理包装服务器环境下的异常抛出
    if (process.env.VUE_ENV !== 'client') {
      const errhandleInServer = Object.assign(errData, {
        baseUrl: errRes.config.url,
      });
      return Promise.reject(errhandleInServer);
    }
    return Promise.reject(e);
  },
);

export default api;
